module.exports = __webpack_public_path__ + "static/media/q1.ec82b205.png";